module.exports = __webpack_public_path__ + "img/empty-forms.d8af1fd7.svg";